// extracted by mini-css-extract-plugin
module.exports = {"notFoundPage":"not-found_notFoundPage__37Ce-"};